import { Course } from 'src/store/models/timetable/index.js'

const courseCreation = {
  methods: {
    isSubset (mainArray, subsetArray, key = 'id') {
      return mainArray.every(item => subsetArray.find(s => s[key] === item[key]))
    },
    courseAlreadyExists (course) {
      // a course counts as "already exists" when there is a course with the same subject, teachers and grades that already exists in the the database
      return this.getCourse(course)
    },
    similarCourseExists (course) {
      // a course counts as "similar" when there is a course with the same subject, grades and a subset of teachers
      return this.getCourse(course, false)
    },
    getCourse (course, teacherLengthMustMatch = true) {
      const courses = Course.query()
        .where('subject_id', course.subject_id)
        .where('teachers_pivot', (teachers) => {
          if (teacherLengthMustMatch) {
            return teachers.length === course.teachers_pivot.length && this.isSubset(course.teachers_pivot, teachers, 'teacher_id')
          }

          return this.isSubset(course.teachers_pivot, teachers, 'teacher_id')
        })
        .where('grades_pivot', (grades) => grades.length === course.grades_pivot.length && this.isSubset(course.grades_pivot, grades, 'grade_id'))
        .with('subject')
        .all()
      return courses.find((crs) => crs.$id !== course.id)
    }
  }
}

export default courseCreation
